<div class="sph-card">
  <div #saphereWrapper id="saphere-wrapper"></div>

  <div class="intro-modal" *ngIf="showIntro" role="dialog" aria-modal="true">
    <div class="intro-card">
      <div>

                <h3 class="precheck-title mb-2">Aviso importante antes de comenzar</h3>
                <p class="mb-2" style="    font-weight: 400;
    font-family: 'Mulish';">
                    Esta herramienta es referencial y no reemplaza una evaluación médica profesional.
                </p>

                <h5 class="mb-3 font-weight-bold" style="font-weight: 700;
                    color: #0e0087;
                    font-family: 'Mulish';
                    font-size: 18px;">Por favor considera lo siguiente:</h5>

                <ul class="list-unstyle precheck-list">
                    <li class="d-flex mb-3" style="    align-items: center;
                    gap: 17px !important;">
                        <i class="fi fi-rr-comment-info" style="    color: #0e0087;
                    font-size: large;"></i>
                        <p class="mb-0" style="    font-weight: 400;
                            font-family: 'Mulish';">
                            Los datos obtenidos a través de Selfie Salud IA son generados en tiempo real por una herramienta
                            externa y no se almacenan en la plataforma de AlmaMedis.
                        </p>
                    </li>
                    <li class="d-flex mb-3" style="    align-items: center;
                    gap: 17px !important;">
                        <i class="fi fi-rr-comment-info" style="    color: #0e0087;
                    font-size: large;"></i>
                        <p class="mb-0" style="    font-weight: 400;
                            font-family: 'Mulish';">
                            Esta medición es informativa y preliminar; no reemplaza diagnóstico médico formal, análisis
                            clínico
                            ni evaluación presencial.
                        </p>
                    </li>
                    <li class="d-flex" style="    align-items: center;
                    gap: 17px !important;">
                        <i class="fi fi-rr-comment-info" style="    color: #0e0087;
                    font-size: large;"></i>
                        <p class="mb-0" style="    font-weight: 400;
    font-family: 'Mulish';">
                            Si presentas síntomas o dudas sobre tu salud, consulta con un profesional certificado.
                        </p>
                    </li>
                </ul>

            </div>

            <div class="text-center mt-3">
                <div class="loader_ivirtual" *ngIf="isLoading == true" >
                    <div class="loader__figure_ivirtual"></div>
                    <p class="loader__label_ivirtual"></p>
                </div>

                <button class="btn btn-primary btn-lg precheck-cta" *ngIf="isLoading == false" (click)="proceedToMeter()">Aceptar</button>
            </div>
        </div>
    </div>
</div>